import type { UserPublic } from '@repo/types/users';

import { UserLvl } from '@repo/types/enums/userLvl';

/**
 * Returns how many of the given users are students.
 *
 * Group slots ("Liczba miejsc") are seats for students only — teachers and
 * admins in a group don't take one.
 */
export const countStudents = (users: Pick<UserPublic, 'lvl'>[]): number => users.filter((user) => user.lvl === UserLvl.STUDENT).length;

/**
 * Returns the ids of students that don't fit in the group's slots, in the given order.
 * Teachers and admins are never over the limit.
 */
export const getStudentIdsOverSlots = (users: Pick<UserPublic, 'id' | 'lvl'>[], slots: number | null | undefined): Set<number> => {
  if (typeof slots !== 'number') {
    return new Set();
  }

  return new Set(
    users
      .filter((user) => user.lvl === UserLvl.STUDENT)
      .slice(slots)
      .map((user) => user.id)
  );
};
